import React from 'react';

import Link from './Link';

const NavigationDropdownItem = ({item, onClick, className = ''}) => (
  <li className={`list-none ${className}`}>
    <Link
      href={item.link}
      onClick={onClick}
      forceAnchor={item.forceAnchor}
      className="flex py-2 pl-2 pr-8 rounded-lg whitespace-normal transition ease-in-out duration-150 hover:bg-gray-50"
    >
      {item.icon && <item.icon className="h-6 w-6 mr-3 shrink-0 text-indigo" aria-hidden="true" />}
      <div>
        <div className="flex items-center">
          <span className="text-sm text-gray-800 whitespace-nowrap sm:font-medium">{item.title}</span>
          {item.badge && (
            <div className="rounded-full bg-indigo-100 px-2 py-0.5 font-medium text-xs text-indigo-600 whitespace-nowrap ml-2">
              {item.badge}
            </div>
          )}
        </div>
        {item.description && <span className="block text-xs font-normal text-gray-600">{item.description}</span>}
      </div>
    </Link>
  </li>
);

export default NavigationDropdownItem;
